// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"HistoryOfSudoku_contentWrapper__H5Dwy"};